import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { LoginWithDiscordBtn } from '../../components/LoginWithDiscordBtn';

const DiscordRequiredPageOverlay = ({ content }) => {
  const { user } = useAuth();

  const hasAccessToPage = (user?.roles?.length ?? 0) > 0

  // If discord is not required, just render the content
  if (hasAccessToPage) {
    return content;
  }
  
  
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Paper elevation={3} sx={{ p: 4, maxWidth: 500, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          Discord Login Required
        </Typography>
        <Typography variant="body1" paragraph>
          Please login with your Discord account to access this page.
        </Typography>
        <LoginWithDiscordBtn />
      </Paper>
    </Box>
  );
};

export default DiscordRequiredPageOverlay;
